export const getListAlertModal = ({ surveyForm }) => surveyForm.alert;
export const getListConfirmModal = ({ surveyForm }) => surveyForm.confirmModal;

export const getAlertModalData = ({ surveyForm }) => surveyForm.alert;
export const getShowLoading = ({ surveyForm }) => surveyForm.loading;

export const hasLoadedData = ({ surveyForm }) => surveyForm.hasLoadedData;
export const getSurveyFormDetails = ({ surveyForm }) => surveyForm;
export const getSurveyData = ({ surveyForm }) => surveyForm.surveyData;
export const getDetailMode = ({ surveyForm }) => surveyForm.mode;

export const getSurveyAlertModal = ({ surveyForm }) => surveyForm.alert;
export const getSurveyConfirmModal = ({ surveyForm }) => surveyForm.confirmModal;
export const getSurveySubmitAfterModal = ({ surveyForm }) => surveyForm.surveyFormAfterSubmitModal;
